export const common = {
  scanceImg: '/api/platform/v1/file/image' // 浏览照片 例如 https://stage-integrator.etowertech.com/api/aggregator/v1/file/image?imageId=d595e592-1dc3-45e4-b816-d327a176756b
}

export const noLoginTrack = {
  truckingNoTrack: '/trackParcel',
  newTruckingNoTrack: '/api/aggregator/v1/track/trackParcel',
  translateUrl: '/api/platform/v1/translate/textTranslate'
}

export const user = {
  login: '/loginActionTemp',
  logout: '/api/platform/v1/logout',
  queryMenu: '/queryMenu',
  queryMenuNew: '/api/platform/v1/module/session',
  getTenantInfo: '/api/platform/v1/accountManage/getTenantInfo', // 获取租户信息
  getCurrentAggregatorLogoInfo: '/api/platform/v1/accountManage/getCurrentAggregatorLogoInfo' // 获取当前集成商logo信息
}

export const loginApi = {
  preLogin: '/api/platform/v1/preLogin', // 预登录
  login: '/api/platform/v1/syslogin', // 登录
  retrievePassword: '/api/platform/v1/retrievePassword', // 找回密码
  resetPassword: '/api/platform/v1/resetPassword', // 重置密码
  changePassword: '/api/platform/v1/changePassword', // 修改密码
  getBrandInfoByDomainName: '/api/platform/v1/loginPage/getByDomainName', // 获取背景及Logo信息
  getSsoConfig: '/api/platform/v1/ssoConfig/getBySsoType', // 获取第三方登录配置列表
  oauthGetTenants: '/api/platform/v1/oauth2' // 第三方登录获取租户列表
}
